import z from 'zod'

export const feedbackStatusSchema = z.enum(['open', 'resolved'])
export type FeedbackStatus = z.infer<typeof feedbackStatusSchema>

export const consoleLogLevelSchema = z.enum(['error', 'warn', 'unhandled', 'rejection'])
export type ConsoleLogLevel = z.infer<typeof consoleLogLevelSchema>

export const consoleLogEntrySchema = z.object({
    level: consoleLogLevelSchema,
    message: z.string().max(4000),
    timestamp: z.string(),
    stack: z.string().max(8000).optional(),
})
export type ConsoleLogEntry = z.infer<typeof consoleLogEntrySchema>

export const FEEDBACK_TEXT_MAX = 5000
export const FEEDBACK_ATTACHMENTS_MAX = 5
export const FEEDBACK_CONSOLE_LOGS_MAX = 50

export const FEEDBACK_IMAGE_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
] as const
export const FEEDBACK_IMAGE_ACCEPT = FEEDBACK_IMAGE_MIME_TYPES.join(',')

export const feedbackSubmissionSchema = z.object({
    text: z.string().trim().min(1, 'Message is required').max(FEEDBACK_TEXT_MAX),
    image_urls: z.array(z.string().min(1).max(1024)).max(FEEDBACK_ATTACHMENTS_MAX).optional(),
    url: z.string().min(1).max(1024),
    user_agent: z.string().min(1).max(2000),
    viewport_width: z.number().int().min(0).max(100000),
    viewport_height: z.number().int().min(0).max(100000),
    device_pixel_ratio: z.number().min(0).max(100),
    console_logs: z.array(consoleLogEntrySchema).max(FEEDBACK_CONSOLE_LOGS_MAX).optional(),
})
export type FeedbackSubmission = z.infer<typeof feedbackSubmissionSchema>

export const feedbackUpdateStatusSchema = z.object({
    status: feedbackStatusSchema,
})
export type FeedbackUpdateStatus = z.infer<typeof feedbackUpdateStatusSchema>

export const feedbackListQuerySchema = z.object({
    status: feedbackStatusSchema.optional(),
    search: z.string().trim().max(200).optional(),
    page: z.number().int().min(1).optional(),
})
export type FeedbackListQuery = z.infer<typeof feedbackListQuerySchema>

export interface FeedbackListItem {
    id: number
    text: string
    status: FeedbackStatus
    submitter_id: number
    submitter_name: string | null
    submitter_email: string
    created_at_utc: string
    resolved_at_utc: string | null
}

export interface FeedbackDetail extends FeedbackListItem {
    url: string
    user_agent: string
    viewport_width: number
    viewport_height: number
    device_pixel_ratio: number
    console_logs: ConsoleLogEntry[] | null
    resolver_id: number | null
    resolver_name: string | null
    updated_at_utc: string
    attachments: { id: number; image_url: string }[]
}
